import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Rakesh Agarwal",
    meta: "Business owner, Delhi",
    quote: "I had money lying in a savings account for years. Rajkiran explained SIPs in simple words and today my portfolio is something I'm genuinely proud of.",
  },
  {
    name: "Meera Sharma",
    meta: "School teacher, Pitampura",
    quote: "What I appreciated most was zero pressure. He first understood my daughter's education goal, then suggested a plan. The 24-hour call-back promise is real.",
  },
  {
    name: "Pranab Das",
    meta: "Retired engineer, Tinsukia",
    quote: "After retirement I couldn't take risks. The fixed income plan gives me steady monthly peace of mind. Claims and paperwork were handled end to end.",
  },
  {
    name: "Sunita Verma",
    meta: "IT professional, Delhi NCR",
    quote: "I bought term insurance through Rajkiran Wealth after comparing everywhere. He got my family a large cover at a premium lower than I expected.",
  },
  {
    name: "Amit Bhattacharjee",
    meta: "Doctor, Assam",
    quote: "Every year my portfolio is reviewed and rebalanced without me asking. That discipline is exactly what I was missing when I invested on my own.",
  },
  {
    name: "Kavita Singh",
    meta: "Homemaker, Delhi",
    quote: "I started a ₹2,000 SIP thinking it was too small to matter. Three years later, seeing it grow has changed how our whole family thinks about saving.",
  },
];

export const Testimonials = () => (
  <section id="testimonials" className="py-20 lg:py-32 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bronze">Client stories</p>
        <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-forest">
          Families who trust us with their tomorrow
        </h2>
      </motion.div>

      <div className="mt-12 lg:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
            data-testid={`testimonial-card-${i}`}
            className="bg-white border border-border rounded-2xl p-6 lg:p-8 transition-transform duration-300 hover:-translate-y-1 hover:border-forest/40 flex flex-col"
          >
            <Quote className="h-6 w-6 text-bronze" />
            <blockquote className="mt-4 text-sm lg:text-base text-foreground/85 leading-relaxed flex-1">
              {t.quote}
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-border">
              <div className="flex gap-1 mb-2" aria-label="5 star rating">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-bronze text-bronze" />
                ))}
              </div>
              <p className="font-serif text-lg font-medium text-forest">{t.name}</p>
              <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground mt-0.5">{t.meta}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
